import Bundle from "../models/Bundle";
import { useEffect, useState } from "react";
import PackageList from "./PackageList";
import PackageButton from "./PackageButton";
import { PackageTypesProps } from "../models/PropsInterface";
import PackageBenefits from "./PackageBenefits";
import PackageBestSelling from "./PackageBestSelling";
import "../cssStyles/PackageTypes.css";

const PackageTypes = (props: PackageTypesProps) => {
  /*-----------------------------
   *  SET INITIAL ID & ASSIGN ID
   * ----------------------------*/
  const selectId = () => {
    if (!props.packages.length) return 0;
    return props.packages[props.product][
      props.packages[props.product]?.length - 1
    ].productSettingId;
  };

  const selectAssignId = (): number => {
    if (!props.packages.length) return 0;
    return props.packages[props.product][
      props.packages[props.product]?.length - 1
    ].productSettingId;
  };

  /*-----------------------------
   *           STATES
   * ----------------------------*/
  const [selectedPkg, setSelectedPkg] = useState<string>(props.product);
  const [currentBundles, setBundles] = useState<Array<Bundle>>(props.bundles);
  const [selectedBundleId, setSelectedBundleId] = useState<number>(0);
  const [selectedAssignId, setSelectedAssignId] = useState<number>(selectId());
  const [selectedId, setSelectedId] = useState<number>(selectAssignId());

  /*-----------------------------
   *          FUNCTIONS
   * ----------------------------*/
  const setDefaultPkg = (pkg: string, isEmbedded: boolean = false) => {
    if (!Object.keys(props.packages).length) {
      return;
    }

    let defaultPkg = props.packages[pkg][props.packages[pkg]?.length - 1];

    if (props.matchingPackage?.id && isEmbedded) {
      defaultPkg =
        props.packages[props.matchingPackage.group][
          props.packages[props.matchingPackage.group]?.length - 1
        ];

      setSelectedId(props.matchingPackage?.id);
      setSelectedAssignId(props.matchingPackage.productAssignId);
      setSelectedPkg(props.matchingPackage.group);
    } else {
      setSelectedId(defaultPkg.productSettingId);
      setSelectedAssignId(defaultPkg.productAssignId);
      setSelectedPkg(pkg);
    }

    const bundles = props.bundles.filter((bundle) => {
      return bundle.extraInfo.subService.service === pkg;
    });
    setBundles(bundles);

    props.setLabel(
      props.language === "en"
        ? defaultPkg.package["en"]
        : defaultPkg?.package["ar"]
    );
  };

  useEffect(() => {
    const usedBundle = currentBundles.find((bundle) => {
      return bundle.extraInfo.subService.productSettingId === selectedId;
    }) ?? { id: 0 };
    setSelectedBundleId(usedBundle.id);
  }, [selectedId]);

  const setId = (id: number) => {
    const usedPkgIdx = props.packages[selectedPkg].findIndex((pkg) => {
      return id === pkg.productSettingId;
    });
    const usedPkg = props.packages[selectedPkg][usedPkgIdx];
    setSelectedId(usedPkg.productSettingId);
    setSelectedAssignId(usedPkg.productAssignId);
    const usedBundle = currentBundles.find((bundle) => {
      return (
        bundle.extraInfo.subService.productSettingId ===
        usedPkg.productSettingId
      );
    }) ?? { id: 0 };
    setSelectedBundleId(usedBundle.id);
    props.setLabel(
      props.language === "en" ? usedPkg.package["en"] : usedPkg.package["ar"]
    );
  };

  useEffect(() => {
    setDefaultPkg(props.product, true);
  }, [props.product]);

  return (
    <div className={`vas-row package_type__row  vas-mt-2 vas-mb-4`}>
      <div className={`vas-col-12`}>
        {
          <PackageBestSelling
            language={props.language}
            packages={props.packages}
          />
        }
        <div
          className={`${
            props.packageConfig.length > 1
              ? `package_type__package_box vas-mb-3`
              : ""
          } `}
        >
          {props.packageConfig.length > 1
            ? props.packageConfig.map((object) => {
                return (
                  <PackageButton
                    name={object.name}
                    unit={props.packages[object.name][0]}
                    padding={object.padding}
                    selectedName={selectedPkg}
                    onClick={setDefaultPkg}
                    language={props.language}
                    modelId={0}
                  ></PackageButton>
                );
              })
            : ""}
        </div>
      </div>
      <div className={`vas-col-12`}>
        <PackageList
          setIsSuccessProcess={props.setIsSuccessProcess}
          api={props.api}
          domain={props.domain}
          token={props.token}
          countryAbbreviation={props.countryAbbreviation}
          source={props.source}
          modelId={props.modelId}
          setSelectedId={setId}
          selectedId={selectedId}
          selectedAssignId={selectedAssignId}
          selectedBundleId={selectedBundleId}
          currentBundles={currentBundles}
          bundles={currentBundles}
          pos_source={props.pos_source}
          referral_url={props.referral_url}
          packages={props.packages[selectedPkg]}
          language={props.language}
        ></PackageList>
      </div>
      <PackageBenefits
        language={props.language}
        selectedId={selectedId}
        packages={props.packages[selectedPkg]}
      ></PackageBenefits>
    </div>
  );
};

export default PackageTypes;
